import { render, staticRenderFns } from "./provinces.vue?vue&type=template&id=24947e3a&scoped=true"
import script from "./provinces.vue?vue&type=script&lang=js"
export * from "./provinces.vue?vue&type=script&lang=js"
import style0 from "./provinces.vue?vue&type=style&index=0&id=24947e3a&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24947e3a",
  null
  
)

export default component.exports